<template>
  <messenger-chat-message-layout
    direction="outcoming"
    :message-time="message.messageTime"
    :status="status"
  >
    <div v-if="message.name">
      <span class="font-weight-semi-bold">{{ $t('chat.preChatMessage.name') }}:&#32;</span>
      <span class="break-word">{{ message.name }}</span>
    </div>
    <div>
      <span class="font-weight-semi-bold">{{ $t('chat.preChatMessage.email') }}:&#32;</span>
      <span class="break-word">{{ message.email }}</span>
      <messenger-chat-message-info-compensator
        v-if="!message.text"
        :message-time="message.messageTime"
        :status="status"
      />
    </div>
    <div v-if="message.text">
      <span class="font-weight-semi-bold">{{ $t('chat.preChatMessage.message') }}:&#32;</span>
      <span class="break-word">{{ message.text }}</span>
      <messenger-chat-message-info-compensator
        :message-time="message.messageTime"
        :status="status"
      />
    </div>
  </messenger-chat-message-layout>
</template>

<script lang="ts" setup>
import MessengerChatMessageLayout from '@widgets/messenger/components/messages/MessengerChatMessageLayout.vue'
import { type MessengerInitialMessageListItem, MessengerMessageStatus } from '@widgets/messenger/types/chat/message'
import MessengerChatMessageInfoCompensator from '@widgets/messenger/components/messages/MessengerChatMessageInfoCompensator.vue'

defineProps<{
  message: MessengerInitialMessageListItem
}>()

const status = MessengerMessageStatus.DELIVERED
</script>
